var angular=window.angular,ngModule;
try {ngModule=angular.module(["doxy.templates"])}
catch(e){ngModule=angular.module("doxy.templates",[])}
var v1="<div class=\"modal-inner custom-modal custom-modal--medium\">\n<group-call-select-people hide=\"$hide()\" people=\"patients\"></group-call-select-people>\n</div>\n";
var id1="/app/realtime/components/group-call/select-people-popup/select-people-popup.modal.ngtemplate.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;